// extracted by mini-css-extract-plugin
export var backdropBlur = "_5g-0";
export var body = "_5g-5";
export var bodyScroll = "_5g-6";
export var columnFooter = "_5g-7";
export var columnFooterFlush = "_5g-8";
export var contentColumn = "_5g-4";
export var frame = "_5g-3";
export var heroContent = "_5g-c";
export var heroOverlay = "_5g-b";
export var image = "_5g-a";
export var imageWrapper = "_5g-9";
export var modal = "_5g-1";
export var modalMain = "_5g-2";
export var productHeader = "_5g-d";
export var productHeaderIcon = "_5g-e";
export var productHeaderName = "_5g-f";
export var progressIndicator = "_5g-g";